import React from 'react';
import { Zap, Building2 } from 'lucide-react';

export const StepTypeSelection = ({ onSelect }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    <button
      onClick={() => onSelect('mono')}
      className="group p-8 bg-white border-2 border-[#BFC6CC] hover:border-[#397DFF] rounded-xl transition-all hover:shadow-lg"
      data-testid="turpe-type-mono"
    >
      <div className="flex flex-col items-center text-center gap-4">
        <div className="w-16 h-16 bg-[#397DFF]/10 rounded-full flex items-center justify-center group-hover:bg-[#397DFF]/20 transition-colors">
          <Zap className="w-8 h-8 text-[#397DFF]" />
        </div>
        <div>
          <h3 className="text-xl font-heading font-semibold text-[#191D1E] mb-2">
            Analyse Mono-PDL
          </h3>
          <p className="text-sm text-[#687175]">
            Optimisation pour un seul Point De Livraison
          </p>
        </div>
      </div>
    </button>

    <button
      onClick={() => onSelect('multi')}
      className="group p-8 bg-white border-2 border-[#BFC6CC] hover:border-[#397DFF] rounded-xl transition-all hover:shadow-lg"
      data-testid="turpe-type-multi"
    >
      <div className="flex flex-col items-center text-center gap-4">
        <div className="w-16 h-16 bg-[#397DFF]/10 rounded-full flex items-center justify-center group-hover:bg-[#397DFF]/20 transition-colors">
          <Building2 className="w-8 h-8 text-[#397DFF]" />
        </div>
        <div>
          <h3 className="text-xl font-heading font-semibold text-[#191D1E] mb-2">
            Analyse Multi-PDL
          </h3>
          <p className="text-sm text-[#687175]">
            Optimisation consolidée de plusieurs PDL
          </p>
        </div>
      </div>
    </button>
  </div>
);
